import { useState } from "react";
import { faqItems } from "@/mocks/categories";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
            VigorBuy Spreadsheet FAQ
          </h2>
          <p className="text-sm text-foreground-600">
            Common questions about using the VigorBuy Spreadsheet for product discovery and shopping.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-150"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}